const $ = jQuery;

$('.image-slider').each(function () {
	const swiperId = $(this).attr('id');
	const swiperOptions = {
		slidesPerView: 'auto',
		spaceBetween: 200,
		centeredSlides: 1,
		pagination: {
			el: '#' + swiperId + '-pagination',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
			nextEl: '#' + swiperId + '-next',
			prevEl: '#' + swiperId + '-prev',
		},
	};

	// eslint-disable-next-line no-undef
	new Swiper('#' + swiperId, swiperOptions);
});
